import React from 'react';
import classnames from 'classnames';
import _ from 'lodash';
import history from 'app/routes/history';
import SectionGroup from 'app/components/general/SectionGroup';
import Button from 'app/components/general/Button';
import CustomersTableSelectable from 'app/components/customers/CustomersTableSelectable';
import CustomersTableRemovable from 'app/components/customers/CustomersTableRemovable';
import DynamicRightBar from 'app/components/layout/DynamicRightBar';
import ModalConfirm from 'app/components/general/ModalConfirm';

interface IStep2SelectPeopleProps {
  actions: any;
  organisations: any;
  organisationTags: any;
  people: any;
  groups: any;
  appReady: boolean;
  updateSelectedRows: Function;
  handleChangePayeeType: Function;
  selectedRows: any;
  selectedRowIds: string[];
  selectRow: Function;
  selectAllRows: Function;
  removeRow: Function;
  removeAllRows: Function;
}

interface IStep2SelectPeopleState {
  selectType: string;
  selected: boolean;
  changeModalOpen: boolean;
}

export default class Step2SelectPeople extends React.Component<IStep2SelectPeopleProps, IStep2SelectPeopleState> {
  static defaultProps: IStep2SelectPeopleProps = {
    actions: undefined,
    organisations: undefined,
    organisationTags: undefined,
    people: undefined,
    groups: undefined,
    appReady: false,
    updateSelectedRows: undefined,
    handleChangePayeeType: undefined,
    selectedRows: undefined,
    selectedRowIds: [],
    selectRow: undefined,
    selectAllRows: undefined,
    removeRow: undefined,
    removeAllRows: undefined,
  };

  state: IStep2SelectPeopleState = {
    selectType: 'individuals',
    selected: true,
    changeModalOpen: false,
  };

  handleChangeSelectType = (selectType: string): void => {
    const state = {
      selectType,
      selected: true,
    };

    this.setState(state);
    this.props.handleChangePayeeType(selectType);
  };

  handleOpenChangeModal = () => {
    this.setState((prevState) => ({
      changeModalOpen: true,
    }));
  };

  handleCloseChangeModal = () => {
    this.setState((prevState) => ({
      changeModalOpen: false,
    }));
  };

  handleBack = () => {
    history.push('/payments/segments/requests/new');
  };


  handleCancelSelectType = (): void => {
    const state = {
      selectType: '',
      selected: false,
      changeModalOpen: false,
    };

    this.setState(state);
    this.props.removeAllRows();
  };

  renderChangeModal = (): React.ReactNode => (
    <ModalConfirm
      title="Change payee type"
      description="This will de-select any individuals/groups already selected."
      buttonText="Change"
      isOpen={this.state.changeModalOpen}
      handleSubmit={this.handleCancelSelectType}
      handleCancel={this.handleCloseChangeModal}
    />
  );

  render(): React.ReactNode {
    const selectedRowsById = _.pick(this.props.people.peopleById, this.props.selectedRowIds);
    return (
      <div className="with-right-bar-margin">
        <div className="row">
          <div className="col">
            {this.props.children}
          </div>
        </div>
        {!this.state.selected && (
          <div className="row with-margin-top">
            <div className="col">
              <SectionGroup title="Select Payee/s">
                <h3 className="text-weight-medium-bold">Who do you need to collect money from?</h3>
                <div className="form-description text-grey with-margin-top">
                  Select the type of payment you will be collecting. This will not be visible to payees. You can request payments from teams (i.e. team manager / contact) or indviduals.
                </div>
                <div className="row with-margin-top-10">
                  <div className="col">
                    <Button onClick={(): void => this.handleChangeSelectType('individuals')} className={classnames({ 'btn-1': this.state.selectType === 'individuals', 'btn-2': this.state.selectType !== 'individuals' })}>Individual/s</Button>
                    {/* <Button onClick={(): void => this.handleChangeSelectType('teams')} className={classnames('with-margin-left', { 'btn-1': this.state.selectType === 'teams', 'btn-2': this.state.selectType !== 'teams' })}>Team/s</Button> */}
                  </div>
                </div>
              </SectionGroup>
            </div>
          </div>
        )}
        {this.state.selectType === 'individuals' && (
          <>
            <div className="row with-margin-top">
              <div className="col">
                <CustomersTableSelectable
                  appReady={this.props.appReady}
                  actions={this.props.actions}
                  peopleIds={this.props.people.peopleIds}
                  peopleById={this.props.people.peopleById}
                  selectedRows={this.props.selectedRows}
                  selectedRowIds={this.props.selectedRowIds}
                  selectedRowsById={selectedRowsById}
                  selectRow={this.props.selectRow}
                  selectAllRows={this.props.selectAllRows}
                  selectedAllRows={this.props.selectedAllRows}
                  removeRow={this.props.removeRow}
                  removeAllRows={this.props.removeAllRows}
                  pagination={this.props.people.pagination}
                  isLoading={this.props.people.isLoading}
                  updateSelectedRows={this.props.updateSelectedRows}
                  manual
                  filterable
                  groups={this.props.groups}
                  organisationTags={this.props.organisationTags}
                />
              </div>
            </div>
            <DynamicRightBar>
              <CustomersTableRemovable
                appReady={this.props.appReady}
                actions={this.props.actions}
                peopleIds={this.props.selectedRowIds}
                peopleById={selectedRowsById}
                selectedRows={this.props.selectedRows}
                selectedRowIds={this.props.selectedRowIds}
                selectedRowsById={selectedRowsById}
                selectRow={this.props.selectRow}
                selectAllRows={this.props.selectAllRows}
                removeRow={this.props.removeRow}
                removeAllRows={this.props.removeAllRows}
                pagination={this.props.people.pagination}
                isLoading={this.props.people.isLoading}
                updateSelectedRows={this.props.updateSelectedRows}
                manual
                filterable={false}
                groups={this.props.groups}
                organisationTags={this.props.organisationTags}
              />
            </DynamicRightBar>
          </>
        )}
        {this.renderChangeModal()}

        <div className="row with-margin-top">
          <div className="col btn-flex-group">
            <div className="btn-flex-container">
              {this.state.selected && (
                <Button
                  className="btn-standard btn-1"
                  type="submit"
                  onClick={() => {
                    history.push('/payments/segments/requests/new/notifications');
                  }}
                >
                  Next
                </Button>
              )}
              {this.state.selected && (<Button onClick={this.handleOpenChangeModal} className="btn-standard btn-2">Change payee type</Button>)}
              {!this.state.selected && (<Button onClick={this.handleBack} className="btn-standard btn-2">Back</Button>)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
